// extracted by mini-css-extract-plugin
module.exports = {"companyAuth":"company_companyAuth__dG5nV","modalContent":"company_modalContent__28Tbz"};